<template>
  <div
    scroll="keep"
    class="modal-card"
  >
    <div class="is-expanded">
      <div class="modal-header">
        <img src="/static/svg/icon-cannot-ex.svg">
        <div class="modal-header--title">
          {{ $t('exchange.token_can_not_be_exchanged') }}
        </div>
        <div class="modal-header--sub-title">
          {{ $t('exchange.token_can_not_be_exchanged_detail') }}
        </div>
        <div
          class="modal-header-close-btn"
          @click="$parent.close()"
        >
          <img src="/static/svg/icon-close.svg">
        </div>
      </div>
      <div class="is-expanded">
        <div v-if="!isActive">
          <div
            class="detail"
            @click="goToPage('SendConfirmationEmail')"
          >
            <div class="left">
              <div class="ic">
                <img
                  src="/static/svg/login-icon-email.svg"
                  style="height: 20px;"
                >
                <span>
                  {{ $t('exchange.confirm_email') }}
                </span>
              </div>
            </div>
            <div class="right">
              <img
                src="/static/svg/icon-warning.svg"
                class="ic-alert"
              >
              <span class="text">
                {{ $t('exchange.confirm_email_detail') }}
              </span>
              <img
                src="/static/svg/arrow-forward.svg"
                class="ic-arrow"
              >
            </div>
          </div>
        </div>
        <div v-if="isActive && !isPassKyc">
          <div
            class="detail"
            @click="goToPage('KYC')"
          >
            <div class="left">
              <div class="ic">
                <img src="/static/svg/icon-kyc-profile.svg">
                <span>
                  {{ $t('menu.kyc') }}
                </span>
              </div>
              <div class="reward">
                {{ $t('messages.for_receive') }} 500 KUL
              </div>
            </div>
            <div class="right">
              <img
                src="/static/svg/icon-warning.svg"
                class="ic-alert"
              >
              <span class="text">
                {{ $t('exchange.kyc_detail') }}
              </span>
              <img
                src="/static/svg/arrow-forward.svg"
                class="ic-arrow"
              >
            </div>
          </div>
          <div class="divider"/>
        </div>
        <div v-if="isActive && !isSubmitSuitabilityTest">
          <div
            class="detail"
            @click="goToPage('SuitabilityTest')"
          >
            <div class="left">
              <div class="ic">
                <img src="/static/svg/icon-suitability-test.svg">
                <span>
                  {{ $t('menu.suit_test') }}
                </span>
              </div>
            </div>
            <div class="right">
              <img
                src="/static/svg/icon-warning.svg"
                class="ic-alert"
              >
              <span class="text">
                {{ $t('exchange.suit_test_detail') }}
              </span>
              <img
                src="/static/svg/arrow-forward.svg"
                class="ic-arrow"
              >
            </div>
          </div>
          <div class="divider"/>
        </div>
        <div v-if="isActive && !isSubmitKnowledgeTest">
          <div
            class="detail"
            @click="goToPage('KnowledgeTest')"
          >
            <div class="left">
              <div class="ic">
                <img src="/static/svg/icon-knowledge-test.svg">
                <span>
                  {{ $t('menu.knowledge_test') }}
                </span>
              </div>
            </div>
            <div class="right">
              <img
                src="/static/svg/icon-warning.svg"
                class="ic-alert"
              >
              <span class="text">
                {{ $t('exchange.knowledge_test_detail') }}
              </span>
              <img
                src="/static/svg/arrow-forward.svg"
                class="ic-arrow"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertEventNotPass',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isPassKyc: {
      type: Boolean,
      default: false
    },
    isSubmitSuitabilityTest: {
      type: Boolean,
      default: false
    },
    isSubmitKnowledgeTest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToPage (name) {
      this.$router.push({ name })
      this.$parent.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-card {
  background-color: #fff;
  border-radius: 5px;
  padding: 30px 40px 60px 30px;
  width: 100%;
  overflow: auto;
}
.modal-header {
  margin-bottom: 70px;
  font-family: Roboto;
  font-size: 30px;
  font-weight: bold;
  color: #000000;
  text-align: center;
  &--title {
    font-family: Roboto;
    font-size: 25px;
    font-weight: bold;
    color: #dc3731;
  }
  &--sub-title {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    color: #1e1e1e;
  }
}
.modal-header-close-btn {
  position: absolute;
  top: 15px;
  right: 19px;
}
.modal-header-close-btn {
  cursor: pointer;
}
.submit-btn {
  width: 100%;
  margin: 0 auto;
  padding: 9px;
  color: #fff;
  font-weight: bold;
  background-color: #2193ff;
  border-radius: 3px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
.t-al-center {
  text-align: center;
}
.detail {
  padding: 14px 32px 0;
  min-height: 80px;
  cursor: pointer;
  display: flex;

  .left {
    width: 145px;
    float: left;
    .ic {
      float: left;
      img {
        float: left;
      }
      span {
        margin-left: 10px;
        vertical-align: middle;
        line-height: 25px;
      }
    }
    .reward {
      font-size: 12px;
      letter-spacing: 0.24px;
      color: #9b9b9b;
      float: left;
      margin-top: 10px;
    }
  }
  .right {
    float: left;
    width: calc(100% - 145px);
    .ic-alert {
      float: left;
      margin: 0 17px 0 30px;
    }
    .text {
      float: left;
      width: 75%;
    }
    .ic-arrow {
      float: right;
    }
  }
}
.detail:hover {
  background-color: #f3f3f3;
}
.divider {
  float: left;
  width: 100%;
  height: 1px;
  background-color: #e4e4e4;
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .modal-card {
    padding: 20px 15px;
  }
  .modal-header {
    margin-bottom: 20px;
  }
  .detail {
    padding: 5px;
    .left {
      width: 110px;
      .ic {
        span {
          margin: 0;
          width: 100%;
        }
      }
    }
    .right {
      width: calc(100% - 110px);
      .ic-alert {
        float: left;
        margin: 0 10px 0 0;
      }
      .text {
        width: calc(100% - 20px - 10px - 10px - 16px);
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AlertEventNotPass.vue